/* eslint-disable max-lines */
import { Injectable, inject } from '@angular/core';
import { UserSessionService } from '@com-delta-idp/mnx-oauth';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { DATALAYER_PAGE_EVENTS } from '../constants/analytics-constants';
import { VIEW_NAME } from '../constants/login-constant';
import { LoginModalService } from '../services';
import { FacadeHelperService } from './facade-helper.service';

export const IS_STANDALONE_PAGE$ = new BehaviorSubject(false);
@Injectable({
  providedIn: 'root'
})
export class FacadeService extends FacadeHelperService {
  loginAuthScreenContent$;
  flowIdForTheTransaction!: string | undefined;
  isEmailAllowed!: boolean | undefined;
  standalonePage = false;
  loginModalService = inject(LoginModalService);
  userSessionService = inject(UserSessionService);
  constructor() {
    super();
    this.getPageContent();
    this.loginAuthScreenContent$ = this.loginContent$.asObservable();
  }

  getPageContent(makeBackendCall = false, fromApp?: string | undefined) {
    this.fromApplication = fromApp;

    if (Object.keys(this.loginDashboardResponse).length !== 0) {
      this.processLoginDashboard(
        this.loginDashboardResponse,
        this.authenticationConfig,
        this.standalonePage
      );
      return;
    }

    if (
      this.loginAuthenticationHelperService.checkForMakingBackendCall(
        this.flowIdForTheTransaction
      )
    ) {
      this.resetForm();
    }
    if (this.backEndCallCheck(makeBackendCall)) {
      /* Adding below logic of login/loginPage BFF, which refreshes the page, if the user already has a session */
      this.deleteCookieOnBffResponse();
      this.contentService
        .getStaticContentForLoginAuthScreen()
        .subscribe(async (response) => {
          this.aemContent = response[0];
          this.authenticationConfig = response[1];
          await this.loginServiceWoker.registerServiceWorker(
            this.authenticationConfig
          );
          this.isEmailAllowed = this.authenticationConfig.IS_EMAIL_ALLOWED; // False for Delta and True for VS
          this.pingAdapter.nuTravelStartSlo(this.authenticationConfig);
          const transformedContent = await this.adapter.getLoginContent(
            this.aemContent,
            response[1],
            this.loginModalService.skyMilesNumber
          );
          this.loginAuthenticationScreenContent =
            this.loginAuthenticationHelperService.getTransformedContent(
              transformedContent,
              this.aemContent
            );
          this.flowIdForTheTransaction =
            this.loginAuthenticationScreenContent?.authenticationEnabled?.loginAuthWithCredentials?.id;
          this.loginContent$.next(this.loginAuthenticationScreenContent);
          this.loginHelperUtils.isRecognitionRoute();
          this.displayMfaResetPasswordMessage();

          if (
            this.loginAuthenticationScreenContent?.authenticationEnabled
              ?.accountLocked
          ) {
            this.dataLayerServcie.triggerLoginDataLayerEvents(
              DATALAYER_PAGE_EVENTS.LOGIN_UNLOCK_ACCOUNT
            );
            this.nextDisplayViewService.nextDisplayView(
              VIEW_NAME.UNLOCK_ACCOUNT_SCREEN
            );
          }
          this.checkLastName(this.isEmailAllowed);
          if (!transformedContent.authenticationEnabled?.errorId) {
            if (transformedContent.authenticationEnabled?.access_token) {
              this.updateLoaderAndDisableButton(true);
              await this.loginRememberMeUtils.sendTokenServiceWorker(
                this.authenticationConfig,
                transformedContent.authenticationEnabled
              );
              this.getDashBrdDataBffCall(
                undefined,
                transformedContent.authenticationEnabled.access_token,
                this.authenticationConfig,
                this.fromApplication,
                this.standalonePage
              );
            }
          }
          this.getStoredRmeCookie();
          this.flowRouter.getSetupMfaFlag(this.authenticationConfig);
        });
    }
  }

  deleteCookieOnBffResponse() {
    if (
      this.cookieHelper.getCookieValue('accountType') &&
      !this.standalonePage &&
      this.warmStateCheck()
    ) {
      this.userSessionService.getUserSession().subscribe((response) => {
        if (response?.smNumber) {
          this.nuTravelSkyBonusUtilService.redirectUserToRefreshUrl(
            this.fromApplication,
            this.redirectUrl,
            window.location.href,
            this.authenticationConfig
          );
        } else {
          this.coreUtilService.setCookieName(
            'accountType',
            '',
            0,
            false,
            this.authenticationConfig
          );
          if (this.cookieHelper.getCookieValue('accountType')) {
            this.coreUtilService.deleteCookie('accountType');
          }
        }
      });
    }
  }

  warmStateCheck() {
    return !(
      this.coreUtilService.get('encyToken') && this.coreUtilService.get('uid')
    );
  }

  backEndCallCheck(makeBackendCall: boolean): boolean {
    return makeBackendCall && !this.flowIdForTheTransaction;
  }

  displayMfaResetPasswordMessage() {
    const urlParams = new URLSearchParams(window.location.search);
    const verified = urlParams.get('verified') ?? '';

    if (verified === 'true') {
      this.contentService
        .getAEMContent()
        .pipe(take(1))
        .subscribe(({ commonOverlayMessages }) => {
          const { createPassword_Success } = commonOverlayMessages;
          this.getContent().errorMessage = createPassword_Success;
          this.getContent().pageContent.mfaSuccess = true;
          this.getContent().loginFormAttributes.formAlertSuccessIcon = true;
        });
    }
  }
}
